
function koWillCallAction(deliveryType) {
	const sameAsShipping =
		document.getElementById('sameAsShipping').checked === true

	$('.secondRequired__icon.hiddenAsWillCall').toggle(
		sameAsShipping && deliveryType !== 'willcall'
	)
	$('.shippingRequired__icon.hiddenAsWillCall').toggle(
		!sameAsShipping && deliveryType !== 'willcall'
	)
}

export default koWillCallAction
